import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react'
import { RecentEntity } from '../hooks/useRecentEntities'

interface QuickNavContextType {
  isOpen: boolean
  toggleSidebar: () => void
  openSidebar: () => void
  closeSidebar: () => void
  currentEntity: RecentEntity | null
  setCurrentEntity: (entity: RecentEntity | null) => void
}

export const QuickNavContext = createContext<QuickNavContextType | undefined>(undefined)

export function QuickNavProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(true) // Default to open
  const [currentEntity, setCurrentEntity] = useState<RecentEntity | null>(null)

  const toggleSidebar = useCallback(() => {
    setIsOpen((prev) => !prev)
  }, [])

  const openSidebar = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeSidebar = useCallback(() => {
    setIsOpen(false)
  }, [])

  const value: QuickNavContextType = {
    isOpen,
    toggleSidebar,
    openSidebar,
    closeSidebar,
    currentEntity,
    setCurrentEntity,
  }

  return <QuickNavContext.Provider value={value}>{children}</QuickNavContext.Provider>
}

export function useQuickNav() {
  const context = useContext(QuickNavContext)
  if (context === undefined) {
    throw new Error('useQuickNav must be used within a QuickNavProvider')
  }
  return context
}
